<template>
    <div class="setting-page-content-wrapper api-access">
        <div class="page-header">
            <div class="title">{{ $t("settings.apiAccessTitle") }}</div>
            <div class="subtitle">{{ $t("settings.apiAccessSubtitles") }}</div>
        </div>
        <section>
            <div>
                <a-card :title="$t('settings.apiAccessTokenCardTitle')" style="width: 500px">
                    <a-card-grid style="width: 100%; text-align: center">
                        <div v-if="!!access_token" class="tokenView">
                            <div>{{ access_token.token }}</div>
                        </div>
                    </a-card-grid>
                    <a-card-grid style="width: 100%; text-align: center" :hoverable="false">
                        <a-button class="btnColor" type="primary" @click="generateToken" danger ghost>
                            {{ $t("message.generateToken") }}
                        </a-button>
                        <a-button class="btnColor" type="primary" @click="copyAccessToken" danger ghost>
                            {{ $t("message.copyToken") }}
                        </a-button>
                        <a-button class="btnColor" type="secondary" @click="goToApiDoc" danger ghost>
                            {{ $t("message.ApiDoc") }}
                        </a-button>
                    </a-card-grid>
                </a-card>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState } from "vuex";
import log2 from "../../../../utils/log2";
import WirelessKeyboardIcon from "../../../../components/svg/icons/WirelessKeyboardIcon.vue";
import FeatureItem from "../components/FeatureItem.vue";
import request from "../../../../utils/request";

const log = log2("Settings/ApiAccess");

export default {
    name: "ApiAccess",
    components: {
        WirelessKeyboardIcon,
        FeatureItem,
    },
    props: {
        updateSettings: {
            type: Function,
            required: true,
        },
    },

    computed: {
        ...mapState({
            settings: (state) => state.setting.settings,
            site: (state) => state.site.site,
        }),
    },
    data() {
        return {
            access_token: null,
        };
    },
    methods: {
        async generateToken() {
            try {
                const { data } = await request.post("/access-token/generate-token");
                this.access_token = data.access_token;
            } catch (e) {}
        },
        copyAccessToken() {
            const el = document.createElement("textarea");
            el.value = this.access_token.token;
            document.body.appendChild(el);
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
            this.$message.success(this.$t("message.tokenCopied"));
        },
        goToApiDoc() {
            window.open("https://doc.supsis.live/api/", "_blank");
        },
        async getToken() {
            try {
                const { data } = await request.get("/access-token");
                this.access_token = data.access_token;
            } catch (e) {}
        },
    },
    mounted() {
        this.getToken();
    },
    watch: {},
};
</script>

<style lang="scss">
.setting-page-content-wrapper {
    &.api-access {
        .tokenView {
            overflow-y: scroll;
            white-space: nowrap;
        }

        .btnColor {
            border-color: var(--color-bg-primary-default) !important;
            color: var(--color-bg-primary-default) !important;
        }
    }
}

.dark-mode {
    .setting-page-content-wrapper {
        &.api-access {
            .ant-card.ant-card-bordered {
                background: #343441 !important;
                color: #ffffff !important;
                border: solid 2px #fff;
            }
        }
    }
}
</style>
